import { render, staticRenderFns } from "./PanelInputWrap.vue?vue&type=template&id=2044ec33&"
import script from "./PanelInputWrap.vue?vue&type=script&lang=js&"
export * from "./PanelInputWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports